
import { supabase } from "@/integrations/supabase/client";
import { AppointmentResult } from "./types";

export async function getAppointments(includeArchived = false, date?: Date, clientId?: string): Promise<AppointmentResult> {
  try {
    // Obter usuário atual
    const { data: userData } = await supabase.auth.getUser();
    if (!userData?.user) {
      console.error("Usuário não autenticado");
      return { success: false, error: { message: "Usuário não autenticado" }, data: [] };
    }
    
    let query = supabase
      .from("appointments")
      .select("*, client:appointments_client_id_fkey(name)")
      .eq("user_id", userData.user.id)
      .order("date");
    
    if (!includeArchived) {
      query = query.eq("archived", false);
    }

    if (clientId) {
      query = query.eq("client_id", clientId);
    }

    if (date) {
      // Filter by the date part only
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      
      const endOfDay = new Date(date);
      endOfDay.setHours(23, 59, 59, 999);
      
      query = query
        .gte("date", startOfDay.toISOString())
        .lte("date", endOfDay.toISOString());
    }

    const { data, error } = await query;

    if (error) {
      console.error("Erro ao buscar compromissos:", error);
      return { success: false, error, data: [] };
    }

    return { success: true, data };
  } catch (error: any) {
    console.error("Erro ao buscar compromissos:", error);
    return { success: false, error, data: [] };
  }
}

export async function getAppointmentById(appointmentId: string): Promise<AppointmentResult> {
  try {
    const { data, error } = await supabase
      .from("appointments")
      .select("*, client:appointments_client_id_fkey(name)")
      .eq("id", appointmentId)
      .maybeSingle();

    if (error) {
      console.error("Erro ao buscar compromisso:", error);
      return { success: false, error, data: null };
    }

    return { success: true, data };
  } catch (error: any) {
    console.error("Erro ao buscar compromisso:", error);
    return { success: false, error, data: null };
  }
}
